import React from 'react';
import { useProctor } from '../../context/ProctorContext';
import { ContextKey } from '../../types';
import { fmtTimer } from '../../engine/stats';

export function Header() {
  const { phase, contextKey, setContextKey, riskLevel, startTime } = useProctor();
  const elapsed = startTime ? (Date.now() - startTime) / 1000 : 0;

  const riskClass = riskLevel >= 60 ? 'risk-high' : riskLevel >= 30 ? 'risk-medium' : 'risk-low';
  const riskLabel = riskLevel >= 60 ? 'HIGH' : riskLevel >= 30 ? 'MEDIUM' : 'LOW';

  return (
    <div className="header" style={{ display: phase === 'ready' ? 'none' : undefined }}>
      <div className="header-left">
        <h1>Dr. Simon AI Proctoring</h1>
        <span>멀티모달 시험감독</span>
      </div>
      <div className="header-center">
        <select
          className="ctx-select"
          value={contextKey}
          onChange={e => setContextKey(e.target.value as ContextKey)}
        >
          <option value="EXAM">시험 (EXAM)</option>
          <option value="QUIZ">퀴즈 (QUIZ)</option>
          <option value="PRACTICE">연습 (PRACTICE)</option>
        </select>
        <span className={`phase-badge ${phase}`}>
          {phase === 'calibrating' ? '캘리브레이션' : phase === 'monitoring' ? '모니터링' : '대기'}
        </span>
      </div>
      <div className="header-right">
        <span className="timer">{fmtTimer(elapsed)}</span>
        <span className={`risk-badge ${riskClass}`}>{riskLabel}</span>
      </div>
    </div>
  );
}
